import React from 'react';
import { useParams } from 'react-router-dom';
import { AuthenticatedPageLayout } from '@/components/layouts/AuthenticatedPageLayout';
import { Box } from '@mui/material';
import DebtorViewWrapper from '@/components/views/DebtorsView/DebtorViewWrapper';

const ViewDebtorsPage = () => {
	const { dealId } = useParams();

	// Keyed so switching deals (e.g. via global search) remounts the view instead of showing the old deal's data.
	return (
		<AuthenticatedPageLayout>
			<Box pb={3}>
				<DebtorViewWrapper key={dealId} />
			</Box>
		</AuthenticatedPageLayout>
	);
};

export default ViewDebtorsPage;
